module.exports = __webpack_public_path__ + "static/media/success_modal_image.94cdf52e.png";